import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CaseManagementService } from '../../../services/caseManagement.service';
import { ShowWoPopupComponent } from '../show-wo-popup/show-wo-popup.component';

@Component({
  selector: 'wo-active-popup',
  templateUrl: './wo-active-popup.component.html',
  styleUrls: ['./wo-active-popup.component.scss']
})
export class WoActivePopupComponent implements OnInit {

  popupHeader: String;
  WorkOrderCount: any;
  showCustomer: boolean = false;
  showTeam: boolean = true;
  woByTeam = [];
  woByCustomer = [];
  teamAverageMins: number = 0;
  customerAverageMins: number = 0;
  totalWOCount: Number = 0;
  teamMaxTime: number = 0;
  teamMinTime: number = 0;
  customerMaxTime: number = 0;
  customerMinTime: number = 0;
  loading: boolean = false;
  tableHeader: String = ""

  constructor(
    public dialogRef: MatDialogRef<WoActivePopupComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private caseManagementService: CaseManagementService
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    if (this.data.statusPrecedence == 7 || this.data.statusPrecedence == 8 || this.data.statusPrecedence == 9) {
      this.tableHeader = "Pending Time (Mins)";
    } else {
      this.tableHeader = "Max DIP (Mins)";
    }
    this.totalWOCount = this.data.count;
    let avgTeamTime = 0;
    let avgCustomerTime = 0;
    let teamMaxTime: number = 0;
    let teamMinTime: number = 0;
    let customerMaxTime: number = 0;
    let customerMinTime: number = 0;
    this.loading = true;
    this.caseManagementService.getWOCountByStatusPrescendenceByTeamOrCustomer(this.data.statusPrecedence, 1).subscribe((res: any) => {
      this.woByTeam = res;
      teamMinTime = res[0].pendingMins;
      this.woByTeam.forEach(function (WOs) {
        avgTeamTime = avgTeamTime + WOs.pendingMins;
        if (teamMaxTime < WOs.pendingMins)
          teamMaxTime = WOs.pendingMins;
        if (teamMinTime > WOs.pendingMins)
          teamMinTime = WOs.pendingMins;
      });
      this.teamMaxTime = teamMaxTime;
      this.teamMinTime = teamMinTime;
      this.teamAverageMins = Math.round(avgTeamTime / this.woByTeam.length);
      this.loading = false;
    });
    this.loading = true;
    this.caseManagementService.getWOCountByStatusPrescendenceByTeamOrCustomer(this.data.statusPrecedence, 0).subscribe((res: any) => {
      this.woByCustomer = res;
      customerMinTime = res[0].pendingMins;
      this.woByCustomer.forEach(function (WOs) {
        avgCustomerTime = avgCustomerTime + WOs.pendingMins;
        if (customerMaxTime < WOs.pendingMins)
          customerMaxTime = WOs.pendingMins;
        if (customerMinTime > WOs.pendingMins)
          customerMinTime = WOs.pendingMins;
      });
      this.customerMaxTime = customerMaxTime;
      this.customerMinTime = customerMinTime;
      this.customerAverageMins = Math.round(avgCustomerTime / this.woByCustomer.length);
      this.loading = false;
    });
  }

  onNoClick(): void {
    this.dialogRef.close(0);
  }

  changeWOView(e) {
    if (e.checked) {
      this.showCustomer = true;
      this.showTeam = false;
    } else {
      this.showCustomer = false;
      this.showTeam = true;
    }
  }

  public showWOPopup(count, teamKey, customerKey, statusPrecedence): void {
    if (count > 0) {
      this.dialog.open(ShowWoPopupComponent, {
        width: '90%',
        height: 'auto',
        maxHeight: '90%',
        hasBackdrop: true,
        backdropClass: 'cdk-overlay-transparent-backdrop',
        data: { count: count, teamKey: teamKey, customerKey: customerKey, statusPrecedence: statusPrecedence }
      });
    }
  }

}
